const DEFAULT_LINEAL_UNIT_MEASURE = 'cm';
const DEFAULT_WEIGHT_UNIT_MEASURE = 'kg';

export { DEFAULT_LINEAL_UNIT_MEASURE, DEFAULT_WEIGHT_UNIT_MEASURE };
